import { render } from "./getTenantStatement.vue?vue&type=template&id=0ae9cf1a&scoped=true"
import script from "./getTenantStatement.vue?vue&type=script&lang=js"
export * from "./getTenantStatement.vue?vue&type=script&lang=js"

import "./getTenantStatement.vue?vue&type=style&index=0&id=0ae9cf1a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae9cf1a"]])

export default __exports__